export function calculateQuestionCost(baseCost, usageNumber, rule) {
    const repeats = Math.max(0, usageNumber - 1);
    if (rule.type === "LINEAR")
        return baseCost + repeats * (rule.increment ?? baseCost);
    if (rule.type === "MULTIPLIER")
        return baseCost * Math.pow(rule.multiplier ?? 2, repeats);
    return baseCost;
}
